import * as React from 'react';
import { AppRoute } from '~/common/enums/enums';
import { getValidClasses } from '~/helpers/helpers';
import { Link } from '~/components/common/common';
import * as styles from './direction-item.module.scss';

type Props = {
  link: AppRoute;
  isActive: boolean;
};

const DirectionItem: React.FC<Props> = ({ link, isActive, children }) => (
  <li className={styles.tag}>
    <Link
      className={getValidClasses(styles.tagLink, isActive && styles.active)}
      localLink={link}
    >
      {children}
    </Link>
  </li>
);

export { DirectionItem };
